// extracted by mini-css-extract-plugin
module.exports = {"form_container":"styles_form_container__BDcR6"};